import React from 'react'
import styles from './EntryButton.module.css'
import { EntryButtonProps } from './types'

export const EntryButton = ({
    disabled = false,
    isSubmitting = false,
    dataClickLabel,
    onClick,
}: EntryButtonProps) => {
    return (
        <div className={styles.buttonContainer}>
            <button
                className={`${styles.entryButton} ${isSubmitting ? styles.pressed : ''}`}
                disabled={disabled}
                data-click-label={dataClickLabel}
                onClick={onClick}
                type={'submit'}
            >
                無料登録する
                <span className={styles.entryArrow}>＞</span>
            </button>
        </div>
    )
}